import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Menu, MenuProps } from 'antd';

import LogoutIcon from 'assets/images/menu/logout.svg?react';
import { useMedia, useTrans } from 'shared/hooks';
import { EMainRoutes } from 'shared/typings';
import { useSidebarSlice } from 'widgets/Sidebar';

interface INavigationProps extends MenuProps {}

export const Navigation: FC<INavigationProps> = ({ className, ...props }) => {
	const { t } = useTranslation();
	const { menuItems } = useTrans();
	const { toggleOpened } = useSidebarSlice();
	const { pathname } = useLocation();
	const isXl = useMedia('xl');

	const items = !isXl
		? menuItems
		: [
				...menuItems,
				{
					label: <a href={`/${EMainRoutes.ACCOUNT}/${EMainRoutes.LOG_OUT}/`}>{t('Выйти')}</a>,
					key: 'Log out',
					icon: <LogoutIcon />,
				},
			];

	return (
		<Menu
			{...props}
			className={className}
			mode="inline"
			items={items}
			onClick={() => toggleOpened(false)}
			selectedKeys={[pathname.split('/')[1]]}
			selectable={false}
		/>
	);
};
